define('TescoMobile_Customer/js/model/recaptcha-close',['jquery'], function ($) {
  'use strict';

  return {
    initCloseListener: function () {
      let self = this;
      let recaptchaIframes = $("body").find("iframe[title*='recaptcha challenge']").parent().parent();
      $.each(recaptchaIframes, function (i, recaptchaWindow) {
        new MutationObserver(x => recaptchaWindow.style.opacity == 0 && self.onClose()).observe(recaptchaWindow, {
          attributes: true,
          attributeFilter: ['style']
        });
      });
    },
    onClose: function () {
      $('body').trigger('processStop');
    }
  };
});

